const customConfig = {
    // 登录方式
    loginType: {
      loginTypeTitle: '请选择证件类型并输入',
      options: [
        {
          label: '门诊号/住院号',
          value: 'patientCard',
          cardLength: 0,
          // 是否需要对卡号进行转换
          needConvert: false,
        },
        {
          label: '身份证号',
          value: 'patientIdCard',
          // 卡号长度
          cardLength: 0,
        },
      ]
    }
}
export default customConfig;